import XCircle from '@/assets/icons/XCircle.svg';
import { IconButton } from '@/components/IconButton';

interface CloseButtonProps {
  className?: string;
  handler?: () => void;
  slot?: string;
}

export const CloseButton = (props: CloseButtonProps) => (
  <IconButton
    icon={<XCircle />}
    label="Close"
    isRound={true}
    width={24}
    {...props}
  />
);
